import { createTheme } from '@mui/material/styles'

const NUM_CHART_BARS = 10
export const ROWS_PER_PAGE = 100

export const getClinvarVizData = data => {

  let chromSet = new Set()
  let chromNamedArray = {}

  // Find all the unique 'chrom' values:
  data.map((item) => {
    chromSet.add(item['chrom'])
  })

  // Initialise the visualization data:
  for (const item of chromSet) {
    chromNamedArray[item] = {
      'data': [],
      'minPos': 0,
      'maxPos': 0,
      'ranges': [],
    }
  }

  // Group together records that have the same 'chrom' value:
  data.map((item) => {
    chromNamedArray[item['chrom']].data.push(item)
  })

  // Get the minimum & maximum 'pos' values for each 'chrom'. This range will be used to build the bars of the graph:
  for (let key in chromNamedArray) {
    chromNamedArray[key].minPos = chromNamedArray[key].data.reduce((min, item) => item.pos < min ? item.pos : min, chromNamedArray[key].data[0].pos);
    chromNamedArray[key].maxPos = chromNamedArray[key].data.reduce((max, item) => item.pos > max ? item.pos : max, chromNamedArray[key].data[0].pos);
    chromNamedArray[key].barData = buildBarData(chromNamedArray[key])
  }

  return chromNamedArray
}

const buildBarData = chromItem => {
  // The bar graph will display NUM_CHART_BARS bars. Each bar represents a sub-range of 'pos' values (x-axis) and
  //  a count of the number of records in this range (y-axis):
  let barData = []
  let posInterval
  const posRange = +chromItem.maxPos - +chromItem.minPos
  if (posRange < 10) {
    // Not enough of a range - just show one bar:
    barData.push({
      'barMinPos': +chromItem.minPos,
      'barMaxPos': +chromItem.maxPos,
      'label': `${+chromItem.minPos} to \n${+chromItem.maxPos}`,
      'count': chromItem.data.length,
    })
  } else {
    posInterval = Math.round(posRange / NUM_CHART_BARS)
    for (let i = 0; i < NUM_CHART_BARS; i++) {
      const barMinPos = +chromItem.minPos + i * posInterval
      const barMaxPos = i == NUM_CHART_BARS - 1 ? +chromItem.maxPos : barMinPos + posInterval - 1
      const count = chromItem.data.filter((item) => item.pos >= barMinPos && item.pos <= barMaxPos).length;
      barData.push({
        'barMinPos': barMinPos,
        'barMaxPos': barMaxPos,
        'label': `${barMinPos} to \n${barMaxPos}`,
        'count': count,
      })
    }
  }

  return barData
}

const isNoFilter = currentValue => currentValue === 'no_filter'

export const no_filters = filters => {
  return Object.values(filters).every(isNoFilter)
}

const getFilterQueryString = filters => {

  let queryArray = []

  for(const [key, value] of Object.entries(filters))
    if (value !== 'no_filter') {
      queryArray.push(`${key}=${value}`)
    }

  return queryArray.join('&')
}

export const loadData = async (filters, startIndex, endIndex) => {

  let url = process.env.REACT_APP_API_ENDPOINT_BASE

  if (!startIndex) {
    startIndex = 0
  }
  if (!endIndex) {
    endIndex = 100
  }

  url += no_filters(filters) ?
    `/clinvar?startIndex=${startIndex}&endIndex=${endIndex}`  :
    `/variants?${getFilterQueryString(filters)}`

    try {
      const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`)
    }
    const data = await response.json()
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const theme = createTheme({
  typography: {
    body1: {
      fontSize: 16
    },
    body2: {
      fontSize: 16,
      fontWeight: 'bold'
    }
  }
})
